import { useCallback, useEffect, useState } from 'react';
import { getProductsData } from '../../services/pricing/PricingService';
import { ProductResponse } from '../../models/pricing/ProductResponse';

const usePaddleProducts = () => {
  const [products, setProducts] = useState<ProductResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const refreshProducts = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getProductsData();
      setProducts(data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshProducts();
  }, [refreshProducts]);

  return { products, loading, error, refreshProducts };
};

export default usePaddleProducts;
